export default {
  SET_BATCH_CLIENTSS(state, batch_clientss) {
    state.batch_clientss = batch_clientss
  },
  REMOVE_BATCH_CLIENTS(state, itemId) {
      const batch_clientsIndex = state.batch_clientss.datas.findIndex((u) => u.id == itemId)
      state.batch_clientss.datas.splice(batch_clientsIndex, 1)
  },
  SELECTED_BATCH_CLIENTS(state,data){
    state.batch_clientss.datas = []
    state.batch_clientss.total = 1;
    state.batch_clientss.per_page = 1;
    state.batch_clientss.datas.push(data)
  },
  SET_AUTOCOMPLETE_DATA(state,data){
    state.autocomplete_data = data
  },
  EDIT_ITEM(state,data){
    state.elomark_user = data
  },
  ADD_ITEM(state,data){
    state.elomark_user = data
  },
}
